import React, { useState, useEffect, useRef } from "react";
import { Card, Nav, Row, Tab } from "react-bootstrap";

import { SvgComponent } from "components";
import ConfigurarCompania from "views/ConfigurarCompania";
import UsuariosEquipos from "views/UsuariosEquipos";

import { Simplebar } from "components";
import { useConfigurationPage } from "hooks";
import AuthorizationToken from "views/AuthorizationToken";
import { useAuthentication } from "hooks";
import { Permisos } from "utils/permisos";
import ItemList from "views/Item/ItemList";
import "./EntidadesList.scss";
import ItemMain from "views/Item/ItemMain";
import TerminalPOSList from "views/TerminalPOS/TerminalPOSList";
import MetodoPagoList from "views/MetodoPago/MetodoPagoList";
import CargaMasivaPage from "views/CargaMasiva/CargaMasivaPage";
import ClienteList from "views/Cliente/ClienteList";
import CondicionPagoList from "views/CondicionPago/CondicionPagoList";
import LogAuditoriaList from "views/Seguridad/LogAuditoriaList";

let Entidad = "compania";
let Opcion = "";

// ─── Configuración de tabs ────────────────────────────────────────────────────
// Para agregar un nuevo tab, solo añade un objeto a este array.
// Se ordenará alfabéticamente de forma automática.
const NAV_ITEMS = [
    { key: "compania", label: "Compañía", icon: "company", permiso: null },
    { key: "usuarios", label: "Usuarios", icon: "user", permiso: Permisos.Usuario.LISTAR },
    { key: "Autorización", label: "Autorización", icon: "key", permiso: Permisos.Seguridad.CREAR_TOKEN },
    { key: "Items", label: "Items", icon: "item", permiso: Permisos.Items.LISTAR },
    { key: "terminalPOS", label: "Terminal POS", icon: "terminal pos", permiso: Permisos.TerminalPOS.LISTAR },
    { key: "metodoPago", label: "Formas de Pago", icon: "forma-pago", permiso: Permisos.MetodoPago.LISTAR },
    { key: "cargaMasiva", label: "Carga Masiva", icon: "carga-masiva", permiso: Permisos.CargaMasiva.CARGAR },
    { key: "cliente", label: "Clientes", icon: "team", permiso: Permisos.Cliente.LISTAR },
    { key: "condicionPago", label: "Condición de Pago", icon: "condicion-pago", permiso: Permisos.CondicionPago.LISTAR },
    { key: "logAuditoria", label: "Auditoría", icon: "log-historial", permiso: Permisos.LogAuditoria.LISTAR },
];;

// Mapa de componentes por key de tab
const TAB_COMPONENTS = {
  compania:     (props) => <ConfigurarCompania  {...props} />,
  usuarios:     (props) => <UsuariosEquipos     {...props} />,
  Autorización: (props) => <AuthorizationToken  {...props} />,
  Items:        (props) => <ItemMain            {...props} />,
  terminalPOS:  (props) => <TerminalPOSList     {...props} />,
  metodoPago:   (props) => <MetodoPagoList      {...props} />,
  cargaMasiva:  (props) => <CargaMasivaPage     {...props} />,
  cliente:      (props) => <ClienteList         {...props} />,
  condicionPago: (props) => <CondicionPagoList     {...props} />,
  logAuditoria: (props) => <LogAuditoriaList       {...props} />,
};

// ─── Función de ordenamiento alfabético ──────────────────────────────────────
const sortNavItems = (items) =>
  [...items].sort((a, b) =>
    a.label.localeCompare(b.label, "es", { sensitivity: "base" })
  );
// ─────────────────────────────────────────────────────────────────────────────

const EntidadesList = ({ setShowCanvas, showCanvas }) => {
  const [currentTab, setCurrentTab] = useState("");
  const { tienePermiso } = useAuthentication();
  const ref = useRef(null);
  const {
    setConfigurationState,
    setConfigurationLocation,
    getConfigurationLocation,
  } = useConfigurationPage();

  const iconColor = "#3f3f3f";
  const iconStyle = { marginRight: "15px" };
  const navLinkStyle = { width: "100%" };

  useEffect(() => {
    const interval = setInterval(() => {
      try {
        const { location, option } = getConfigurationLocation();
        if (location && Entidad && Entidad !== location) {
          Entidad = location;
          setCurrentTab(location);
        }
        if (Opcion !== "" && option !== Opcion) {
          Opcion = option;
        }
      } catch {}
    }, 200);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (Entidad) {
      setCurrentTab(Entidad);
    } else {
      setCurrentTab("compania");
    }
  }, [Entidad]);

  const handleSelect = (eventKey) => {
    setConfigurationLocation(eventKey);
  };

  const hideLoading = () => ref?.current?.showLoading(false);
  const showLoading = () => ref?.current?.showLoading(true);

  // Filtra por permisos y ordena alfabéticamente
  const visibleNavItems = sortNavItems(
    NAV_ITEMS.filter((item) => item.permiso === null || tienePermiso(item.permiso))
  );

  return (
    <Simplebar
      ref={ref}
      size="xxxl"
      backdrop={true}
      placement={"end"}
      portal={false}
      visible={showCanvas}
      setShow={(e) => setConfigurationState(e)}
      useLoading={true}
      title="Configuración"
      btnLeft={{ show: false, label: "Grabar", func: () => {} }}
      btnRight={{ show: false, label: "Grabar", func: () => {} }}
    >
      <Row
        style={{
          minHeight: "78vh",
          maxHeight: "78vh",
          padding: "0px 0px 0px 15px",
          marginRight: 0,
          marginTop: "0px",
          width: "96vw",
        }}
      >
        {/* ── Sidebar de navegación ── */}
        <Card style={{ width: "15%", overflowY: "auto", paddingTop: "0px" }}>
          <Card.Body
            style={{ paddingTop: "0px", paddingLeft: "0px", marginTop: "0px" }}
          >
            <Nav
              variant="tabs"
              defaultActiveKey="compania"
              activeKey={currentTab}
              className="flex-column"
              onSelect={handleSelect}
              style={{ borderBottom: 0 }}
            >
              {/* Items filtrados y ordenados alfabéticamente */}
              {visibleNavItems.map(({ key, label, icon }) => (
                <Nav.Item key={key}>
                  <Nav.Link eventKey={key} style={navLinkStyle}>
                    <SvgComponent
                      fill={iconColor}
                      iconName={icon}
                      style={iconStyle}
                    />
                    {label}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Card.Body>
        </Card>

        {/* ── Contenido de tabs ── */}
        <Card style={{ width: "80%" }}>
          <Card.Body className="p-0 m-0">
            <Tab.Container
              id="icons-tabs"
              defaultActiveKey="compania"
              activeKey={currentTab}
            >
              <Tab.Content>
                {/* Tabs dinámicos según permisos, ordenados alfabéticamente */}
                {visibleNavItems.map(({ key }) => {
                  const TabComponent = TAB_COMPONENTS[key];
                  return (
                    <Tab.Pane key={key} eventKey={key} className="p-0 m-0">
                      <TabComponent
                        hideLoading={hideLoading}
                        showLoading={showLoading}
                        isActive={currentTab === key}
                        option={Opcion}
                      />
                    </Tab.Pane>
                  );
                })}
              </Tab.Content>
            </Tab.Container>
          </Card.Body>
        </Card>
      </Row>
    </Simplebar>
  );
};

export default EntidadesList;